module.exports = __webpack_public_path__ + "d.no2.9c144252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/d.no2.jpg
// module id = oTrr
// module chunks = 0